// extracted by mini-css-extract-plugin
export default {"button":"FileUploadButton_button__XuQo8","greenBtn":"FileUploadButton_greenBtn__alD-3","inputLabel":"FileUploadButton_inputLabel__YDc2L"};